import React, { PureComponent } from 'react';
import mergeClassNames from 'classnames';

class PaginationPrev extends PureComponent {
    render() {
        const {
            children,
            ...props
        } = this.props;

        return (
            <div {...props}>
                {children}
            </div>
        );
    }
}

PaginationPrev.defaultProps = {};

export default PaginationPrev;
